import { Component } from '@angular/core';
import { CouponFormComponentDef } from '@df/basket/coupon-form.component.def';

export interface ICouponFormData {
    coupon: string | string[];
    checkout?: boolean;
}

@Component({
    selector: 'remove-coupon',
    template: `<button class="p2 col-11" inlineButton (click)="remove()" [status]="removeStatus">{{ 'Remove' | translate }}</button>`
})
export class RemoveCouponComponent extends CouponFormComponentDef {}
